import React from 'react';

const TrialCard = ({ trialData }) => {
  return (
    <div className="border-item p-3 d-flex flex-column gap-16">
      <div className="d-flex align-items-center justify-content-between">
        <div className="f-500 f-black">
          {trialData?.title}
        </div>
      </div>
      <div 
        className="bg-white radius-8 d-flex align-items-center justify-content-between" 
        style={{ padding: '16px' }}
      >
        <div className="d-flex align-items-center gap-8">
          <div>{trialData?.dateRange}</div>
          <div className="f-darkgrey">{trialData?.status}</div>
        </div>
        <div className="d-flex justify-content-end align-items-center">
          {trialData?.progress}
        </div>
      </div>
    </div>
  );
};

export default TrialCard;
